<template>
  <section id="canvas-instructions">
    <copy-link
      :href="
        route('institutions.lti-registrations.create', {
          institution: institutionId,
          _query: {
            lms: 'canvas',
          },
        })
      "
      class="mt-0.5"
    />
  </section>
</template>
<script setup lang="ts">
import {useI18n} from 'vue-i18n';
import CopyLink from './CopyLink.vue';
import {route} from 'ziggy-js';

defineProps<{
  institutionId: number;
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});
</script>
<i18n>
{
  "en": {
  },
  "fr": {
  }
}
</i18n>
